
import Ajax from '../js/common/ajax';
import Utils from '../js/common/utils';
import Qs from "qs";
import {pick} from "xe-utils";

export default {
  //账套管理
  accountSets: {
    list() {
      return Ajax.get("/account-sets")
    },
    page(params = {}) {
      return Ajax.get("/account-sets/page", params)
    },
    download(params = {}) {
      return Ajax.get("/account-sets/download", params, {
        responseType: 'blob'
      })
    },
    load(id) {
      return Ajax.get(`/account-sets/${id}`)
    },
    delete(id, smsCode) {
      return Ajax.delete(`/account-sets/${id}/${smsCode}`)
    },
    batchDelete(params = {}) {
      return Ajax.post(`/account-sets/batchDelete`, params)
    },
    reset(id, smsCode, enableDate, resetType, astName,mobile) {
      return Ajax.get(`/account-sets/reset/${id}`, {smsCode, enableDate, resetType, astName,mobile})
    },
    creatSet(id, resetType, enableDate) {
      return Ajax.get(`/account-sets/creatSet/${id}`, { resetType, enableDate })
    },
    save(params = {}) {
      return Ajax.post(`/account-sets`, params)
    },
    addUser(params = {}) {
      return Ajax.get(`/account-sets/addUser`, params)
    },
    updateUserRole(params = {}) {
      return Ajax.get(`/account-sets/updateUserRole`, params)
    },
    addNewUser(params = {}) {
      return Ajax.get(`/account-sets/addNewUser`, params)
    },
    removeUser(uid, astId) {
      return Ajax.get(`/account-sets/removeUser/${uid}`, {astId})
    },
    checkUse(accountSetsId) {
      return Ajax.get(`/account-sets/checkUse`, {accountSetsId})
    },
    update(params = {}) {
      return Ajax.put(`/account-sets`, params)
    },
    identification(params = {}) {
      return Ajax.post(`/account-sets/identification`, Qs.stringify(params))
    },
    handOver(params = {}) {
      return Ajax.post(`/account-sets/handOver`, Qs.stringify(params))
    },
    batchHandOver(params = {}) {
      return Ajax.post(`/account-sets/batchHandOver`, params)
    },
    updateEncode(params = {}) {
      return Ajax.post(`/account-sets/updateEncode`, params)
    },
    updateCurrentAccountDate(currentAccountDate) {
      return Ajax.get(`/account-sets/update/currentAccountDate`, {currentAccountDate})
    },
    syncCompany() {
      return Ajax.get(`/account-sets/syncCompany`)
    },
    batchOpenQxy(params = {}) {
      return Ajax.post(`/account-sets/batchOpenQxy`, params)
    },
    batchUpdate(params = {}) {
      return Ajax.post(`/account-sets/batchUpdate`, params)
    },
    batchUpdateStatus(params = {}) {
      return Ajax.post(`/account-sets/batchUpdateStatus`, params)
    },
  },
  //凭证字
  voucherWord: {
    list() {
      return Ajax.get("/voucher-word")
    },
    load(id) {
      return Ajax.get(`/voucher-word/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/voucher-word/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/voucher-word`, params)
    },
    update(params = {}) {
      return Ajax.put(`/voucher-word`, params)
    }
  },
  //币别
  currency: {
    list(extendParam) {
      return Ajax.get("/currency", null, extendParam)
    },
    load(id) {
      return Ajax.get(`/currency/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/currency/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/currency`, params)
    },
    update(params = {}) {
      return Ajax.put(`/currency`, params)
    },
    currencyCodeList() {
      return fetch('/data/currency.json').then(resp => resp.json())
    }
  },
  //币别汇率
  currencyRate: {
    list(code) {
      return Ajax.get("/currencyRate?code="+code)
    },
    delete(id) {
      return Ajax.delete(`/currencyRate/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/currencyRate`, params)
    },
    update(params = {}) {
      return Ajax.put(`/currencyRate`, params)
    },
  },
  //科目
  subject: {
    list(type, extendParam) {
      return Ajax.get("/subject?type=" + type, null, extendParam)
    },
    load(id, extendParam) {
      return Ajax.get(`/subject/${id}`, null, extendParam)
    },
    delete(id, extendParam) {
      return Ajax.delete(`/subject/${id}`, extendParam)
    },
    save(params = {}, extendParam) {
      return Ajax.post(`/subject`, params, extendParam)
    },
    update(params = {}, extendParam) {
      return Ajax.put(`/subject`, params, extendParam)
    },
    updateData(params, extendParam) {
      return Ajax.post(`/subject/updateData`, params, extendParam)
    },
    updateStatus(params = {}, extendParam) {
      return Ajax.put(`/subject/status`, params, extendParam)
    },
    voucherSelect(params = {}, extendParam) {
      return Ajax.get(`/subject/voucher/select`, params, extendParam)
    },
    voucherSelectAuxiliary(params = {}, extendParam) {
      return Ajax.get(`/subject/voucher/selectAuxiliary`, params, extendParam)
    },
    nodeSelect(extendParam) {
      return Ajax.get(`/subject/node/select`, null, extendParam)
    },
    toAuxiliary(subjectCode, subjectId, categoryId, extendParam) {
      return Ajax.get(`/subject/to/auxiliary`, {subjectCode, subjectId, categoryId}, extendParam)
    },
    loadByCode(params, extendParam) {
      return Ajax.post(`/subject/loadByCode`, params, extendParam)
    },
    listByCode(code = [], extendParam) {
      return Ajax.get(`/subject/list/ByCode?` + Qs.stringify({code}, {indices: false}), null, extendParam)
    },
    checkUse(subjectCode, extendParam) {
      return Ajax.get(`/subject/checkUse/${subjectCode}`, null, extendParam)
    },
    checkHasData(subjectCode, extendParam) {
      return Ajax.get(`/subject/checkHasData/${subjectCode}`, null, extendParam)
    },
    balance(params = {}, extendParam) {
      return Ajax.post(`/subject/balance`, params, Utils.extend({repeatable: true}, extendParam || {}))
    },
    import(params, extendParam) {
      return Ajax.post(`/subject/import`, params, Utils.extend({'Content-Type': 'multipart/form-data'}, extendParam || {}))
    },
    listByAstId(astId, extendParam) {
      return Ajax.get(`/subject/list/ast`, {astId}, extendParam)
    },
    voucherSelectBalance(params = {}, extendParam) {
      return Ajax.get(`/subject/voucher/selectBalance`, params, extendParam)
    },
    listAuxiliary(params, extendParam){
      return Ajax.get("/subject/listAuxiliary",params, extendParam)
    },
  },
  //科目
  initialBalance: {
    list(params) {
      return Ajax.get("/initial-balance", params)
    },
    currencyList(type) {
      return Ajax.get("/initial-balance/currency", {type})
    },
    load(id) {
      return Ajax.get(`/initial-balance/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/initial-balance/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/initial-balance`, params)
    },
    update(params = {}) {
      return Ajax.put(`/initial-balance`, params)
    },
    trialBalance() {
      return Ajax.get(`/initial-balance/trialBalance`)
    },
    saveAuxiliary(params) {
      return Ajax.post(`/initial-balance/auxiliary`, params)
    },
    import(params) {
      return Ajax.post(`/initial-balance/import`, params, {
        'Content-Type': 'multipart/form-data'
      })
    },
    delAuxiliary(initId, auxiliaryDetailId) {
      return Ajax.delete(`/initial-balance/auxiliary/${initId}/${auxiliaryDetailId}`)
    },
    importBalance(params) {
      return Ajax.post(`/initial-balance/importBalance`, params, {
        'Content-Type': 'multipart/form-data'
      })
    },
    importForeignBalance(params) {
      return Ajax.post(`/initial-balance/importForeignBalance`, params, {
        'Content-Type': 'multipart/form-data'
      })
    },
    importInitialNum(params) {
      return Ajax.post(`/initial-balance/importInitialNum`, params, {
        'Content-Type': 'multipart/form-data'
      })
    },
    importBalanceSave(params) {
      return Ajax.post(`/initial-balance/importSave`, params)
    },
  },
  //辅助核算类别
  accountingCategory: {
    list(extendParam) {
      return Ajax.get("/accounting-category", null, extendParam)
    },
    listByIds(idsList) {
      return Ajax.post("/accounting-category/byid", idsList, {
        repeatable: true
      })
    },
    load(id) {
      return Ajax.get(`/accounting-category/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/accounting-category/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/accounting-category`, params)
    },
    update(params = {}) {
      return Ajax.put(`/accounting-category`, params)
    },
    import(params) {
      return Ajax.post(`/accounting-category/import`, params, {'Content-Type': 'multipart/form-data'})
    },
    download(categoryId, categoryType) {
      return Ajax.get(`/accounting-category/download`, {categoryId, categoryType}, {
        responseType: 'blob'
      })
    }
  },
  accountingCategoryDetails: {
    list(categoryId, params = {}) {
      return Ajax.get(`/accounting-category-details?categoryId=${categoryId}`, params)
    },
    load(id) {
      return Ajax.get(`/accounting-category-details/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/accounting-category-details/${id}`)
    },
    clearData(id, categoryType) {
      return Ajax.delete(`/accounting-category-details/clear/${id}`, {params: {categoryType}})
    },
    save(params = {}) {
      return Ajax.post(`/accounting-category-details`, params)
    },
    saveAd(params = {}) {
      return Ajax.post(`/accounting-category-details/ad`, params)
    },
    update(params = {}) {
      return Ajax.put(`/accounting-category-details`, params)
    },
    loadAuxiliaryAccountingData(params) {
      return Ajax.post(`/accounting-category-details/loadAuxiliaryAccountingData?r=` + Date.now(), params)
    },
    loadAuxiliaryAccountingDataByName(params) {
      return Ajax.post(`/accounting-category-details/loadAuxiliaryAccountingDataByName`, params)
    },
    loadByName(name) {
      return Ajax.get(`/accounting-category-details/loadAuxiliaryAccountingDataByName`, {name})
    },
    loadDetails(category) {
      return Ajax.get(`/accounting-category-details/details`, pick(category, ['id', 'categoryType']))
    }
  },
  //用户
  user: {
    list() {
      return Ajax.get("/user")
    },
    listByAst(astId = null) {
      return Ajax.get("/user/ast/" + astId)
    },
    listByAstCreator(astId = null) {
      return Ajax.get("/user/ast/by/creator", {astId})
    },
    load(id) {
      return Ajax.get(`/user/${id}`)
    },
    loadMobile(id) {
      return Ajax.get(`/user/loadMobile/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/user/delete/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/user/save`, params)
    },
    update(params = {}) {
      return Ajax.put(`/user`, params)
    },
    authAccountSets(userId, params) {
      return Ajax.post("/user/authAccountSets/" + userId, params)
    },
  },
  //模板
  voucherTemplate: {
    list() {
      return Ajax.get("/voucher-template")
    },
    load(id) {
      return Ajax.get(`/voucher-template/${id}`)
    },
    delete(id) {
      return Ajax.delete(`/voucher-template/${id}`)
    },
    save(params = {}) {
      return Ajax.post(`/voucher-template`, params)
    },
    update(params = {}) {
      return Ajax.put(`/voucher-template`, params)
    }
  },
  backup: {
    backup() {
      return Ajax.post(`/backup`)
    },
    list() {
      return Ajax.get(`/backup`)
    },
    delete(id) {
      return Ajax.delete(`/backup/${id}`)
    },
    archive() {
      return Ajax.get(`/backup/archive`)
    },
    archiveStatus() {
      return Ajax.get(`/backup/status/archive`)
    },
    archiveList() {
      return Ajax.get(`/backup/archive/list`)
    },
    archiveDelete(year, doc) {
      return Ajax.delete(`/backup/archive/${year}` + (doc ? "/" + doc : ""))
    },
    upload(formData) {
      return Ajax.post(`/backup/upload`, formData)
    },
    recover(backId, type) {
      return Ajax.get(`/backup/recover/` + backId + "/" + type)
    },
    loadAutoInfo() {
      return Ajax.get(`/backup/auto/info`)
    },
    changeAutoStatus(status) {
      return Ajax.get(`/backup/auto/` + status)
    },
    changeAutoConfig(params) {
      return Ajax.post(`/backup/auto`, params)
    }
  },
  Att: {
    list() {
      return Ajax.get(`/att`)
    },
    delete(attId) {
      return Ajax.delete(`/att/` + attId)
    }
  },
  Sync: {
    copyList(params){
      return Ajax.post(`/sync/copyList`, params)
    },
    initCopyList(params){
      return Ajax.post(`/sync/initCopyList`, params)
    },
    sync(params) {
      return Ajax.post(`/sync`, params)
    },
    syncAst(type, username, params) {
      return Ajax.post(`/sync/${type}/${username}`, params)
    },
    syncMsg(username) {
      return Ajax.get(`/sync/msg/${username}`)
    },
    syncImport(params = {}, extendParam) {
      return Ajax.post(`/sync/import`, params)
    },
    unZipFile(params={}){
      return Ajax.post(`/sync/unzip`, params)
    },
    getFileContent(zipfileName,filePath){
      return Ajax.get(`/sync/getFileContent?zipFileName=`+encodeURIComponent(zipfileName)+"&fileName="+filePath)
    },
    clearAllData(){
      return Ajax.get(`/sync/clearData`)
    },
    getAccountingCategory(){
      return Ajax.get(`/sync/getAccountingCategory`)
    },
    getVoucherWord(){
      return Ajax.get(`/voucher-word`)
    },
    clearDataByFileName(fileName){
      return Ajax.get(`/sync/clearDataByFileName?fileName=`+fileName)
    },
    saveDate(fileName,param=[]){
      if("CHXX.TXT"===fileName){
        return Ajax.post(`/stocks/batchSaveNew`, param)
      }else if("KJKM.TXT"===fileName){
        return Ajax.post(`/subject/batchSave`, param)
      }else if("BMXX.TXT"===fileName){
        return Ajax.post(`/department/batchSave`, param)
      }else if("PERSON.TXT"===fileName){
        return Ajax.post(`/employee/batchSave`, param)
      }else if("XMXX.TXT"===fileName){
        return Ajax.post(`/project/batchSave`, param)
      } else if("WLDW.TXT"===fileName){
        return Ajax.post(`/sync/batchDw`, param)
      }else if(fileName.includes('JZPZ')){
        return Ajax.post(`/sync/batchSaveVoucher`, param)
      }else if("KMYE.TXT"===fileName){
        return Ajax.post(`/initial-balance/syncDataInitial`, param)
      }
    },
    calcBalance(){
      return Ajax.get(`/sync/calcBalance`)
    },
  },
  // 客户上传文件
  customerUpload: {
    list(params = {}) {
      return Ajax.get("/customer-upload/list", params)
    },
    getFileUrl(fileUrl) {
      return Ajax.get("/customer-upload/getFileUrl", {fileUrl})
    }
  }
}
